/**
 * Created by tuki on 2018/12/13.
 */
import axios from 'axios'
import router from '../router'

const myAxios = axios.create();

// http request 拦截器
myAxios.interceptors.request.use(
  config => {
    if (window.sessionStorage.getItem('token')) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers['corona-token'] = window.sessionStorage.getItem('token');
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
myAxios.interceptors.response.use(
  response => {
    let result = response.data;
    if(result.status === 401 || result.status === '401'){
      Toast.fail('登录超时，请重新登录！');
      router.replace({
        path: 'login',
        query: {redirect: router.currentRoute.fullPath}
      });
      return Promise.reject(response.data);
    }
    return response;
  },
  error => {
    return Promise.reject(error)   // 返回接口返回的错误信息
  });

export default myAxios



// WEBPACK FOOTER //
// ./src/util/request.js